import PasswordField from '../../components/accountSecurity/PasswordField';
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { ChallengeInfo, securityError, securityRequest } from '../../services/accountSecurityService';
import SecurityStyles from '../../components/accountSecurity/SecurityStyles';
import DarkModeToggle from '../../components/common/DarkModeToggle';
import BrandStripes from '../../components/common/BrandStripes';
import { getProfileRoute } from '../../utils/profileRoute';

export default function PasswordConfirmationPage() {
    const { user } = useAuth();
    const { isDark } = useTheme();
    const navigate = useNavigate();
    const { state } = useLocation();
    const returnTo = user && ['/perfil', '/profile'].includes(state?.returnTo) ? state.returnTo : user ? getProfileRoute(user) : '/login';
    const [password, setPassword] = useState('');
    const [code, setCode] = useState('');
    const [challenge, setChallenge] = useState<ChallengeInfo | null>(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    async function authorizePasswordChange() {
        await securityRequest('password/start', { password });
        setPassword(''); setCode('');
        navigate('/cambiar-contrasena', { state: { returnTo } });
    }
    async function submit(event: React.FormEvent) {
        event.preventDefault(); setBusy(true); setError('');
        try {
            if (!challenge) {
                const data = await securityRequest<ChallengeInfo>('management/start', { password });
                if (data.requires_2fa) setChallenge(data);
                else await authorizePasswordChange();
            } else {
                await securityRequest('management/verify', { code });
                await authorizePasswordChange();
            }
        } catch (err) { setError(securityError(err)); }
        finally { setBusy(false); }
    }
    return <div className="account-security security-layout" data-dark={isDark}>
        <SecurityStyles />
        <div style={{ position: 'fixed', right: 20, top: 20, zIndex: 20 }}><DarkModeToggle /></div>
        <aside className="security-brand">
            <Link to="/" aria-label="Co Marca, inicio"><img src={`${process.env.PUBLIC_URL}/logo-comarca-blanco.png?v=2`} alt="Co Marca" /></Link>
            <h1>Tu contraseña,<br />tu tranquilidad.</h1>
            <p>Confirma tu identidad antes de elegir una nueva contraseña.</p>
            <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}><BrandStripes /></div>
        </aside>
        <main className="security-main"><div className="security-card">
            <h2>Cambiar contraseña</h2>
            {!user ? <><p>Inicia sesión para cambiar tu contraseña.</p><Link to="/login">Iniciar sesión</Link></> : <>
                <p>{!challenge ? 'Introduce tu contraseña actual. Si tienes verificación en dos pasos activa, también confirmaremos tu segundo factor.' : challenge.method === 'totp' ? 'Introduce un código de tu autenticador o de respaldo.' : challenge.method === 'backup' ? 'Introduce uno de tus códigos de respaldo.' : `Introduce el código enviado a ${challenge.destination}. También puedes usar un código de respaldo.`}</p>
                {error && <div className="security-feedback error" role="alert">{error}</div>}
                <form className="security-form" onSubmit={submit}>
                    {!challenge ? <PasswordField label="Contraseña actual" value={password} onChange={event => setPassword(event.target.value)} autoComplete="current-password" required disabled={busy} /> : <label className="security-field">Código de verificación o respaldo<input value={code} onChange={event => setCode(event.target.value)} autoComplete="one-time-code" maxLength={32} required disabled={busy} /></label>}
                    <button className="security-button" type="submit" disabled={busy}>{busy ? 'Procesando…' : challenge ? 'Confirmar identidad' : 'Continuar'}</button>
                </form>
                <div className="security-actions" style={{ marginTop: 24 }}><Link to="/recuperar-contrasena" state={{ returnTo }}>¿Olvidaste tu contraseña?</Link></div>
                <div style={{ marginTop: 24 }}><Link to={returnTo}>Volver a mi perfil</Link></div>
            </>}
        </div></main>
    </div>;
}
